// Collapse duplicate labels (#164). System/default labels can be re-seeded
// server-side with fresh _ids (#163), and the client applies `find` results via
// `addMany` (append, no reconcile), so stale copies accumulate and would render as
// e.g. 4× "Unread". Dedupe by system `type` (there is only ever one Inbox / Starred
// / etc. per user); custom labels are user-created and distinct — never collapsed.
export function dedupeLabelsByType<T extends { type?: string }>(labels: T[]): T[] {
    const seenSystemTypes = new Set<string>();
    return labels.filter((label) => {
        const type = label?.type;
        if (!type || type === 'custom') return true; // custom labels are distinct
        if (seenSystemTypes.has(type)) return false; // drop duplicate system label
        seenSystemTypes.add(type);
        return true;
    });
}
